import moment from 'moment';

export const searchDateFormat = (date: Date) =>
  moment(date).format('YYYY-MM-DD');

export const UTCFormat = (date: Date) => {
  date.setHours(23, 59, 59, 999);
  return date.toUTCString();
};

export const dateFormatToUTCString = (date: Date) => {
  date?.setHours(0, 0, 0, 0);
  return date?.toUTCString();
};


export const getBeforeDateFromCurrentDate = (days: number): Date => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date;
};

export const getAfterDateFromCurrentDate = (days: number): Date => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
};
